/*
 * Regex to convert numbers into comma separated format(ex. 45200 -> 45,200)
 */
const formatNumToString = (value: number | null): string => {
  if (Number.isNaN(value) || value === null) return '';
  return value.toLocaleString('en-US');
};

export default formatNumToString;
